import { TherapeuticGroupType } from '@dreryk/egabinet-group-session-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { useTriggerLabelExtractor } from './GroupSessionsTypeField.hooks';
import { GroupSessionsTypeFieldFormBeanPart } from './GroupSessionsTypeField.types';

const THERAPEUTIC_GROUP_TYPES: TherapeuticGroupType[] = ['CLOSED'];

type GroupSessionsTypeFieldProps = Pick<FormContextValues<GroupSessionsTypeFieldFormBeanPart>, 'register'>;

export const GroupSessionsTypeField = (props: GroupSessionsTypeFieldProps): JSX.Element => {
   const triggerLabelExtractor = useTriggerLabelExtractor();

   return (
      <Select<TherapeuticGroupType>
         label={translationKeys.type}
         triggerLabelExtractor={triggerLabelExtractor}
         testId={'type'}
         controller={props.register('type', { required: true })}
         defaultValue={'CLOSED'}
         width={'150px'}
         disabled
      >
         <Select.List items={THERAPEUTIC_GROUP_TYPES}>
            {(type) => <Select.Item key={type} item={type} testId={type} label={triggerLabelExtractor(type)} />}
         </Select.List>
      </Select>
   );
};
